import logErrors from '@nykaa/logger/logErrors';
import { ApiHelper } from 'shared/api';


interface AddToWishlist {
  productId: string,
  formKey: string,
}

export const wishlistAdd = async (params: AddToWishlist) => {
  const {
    formKey,
    productId,
  } = params;
  //  FIXME: Have an elegant logic to maintain this
  const url = `/advancedwishlist/index/add/product/${productId}/form_key${formKey}/`;
  const postData = {
    product: productId,
  };

  try {
    const { data: { error, gamoogalist } } = await ApiHelper(`${url}`, 'post', postData);

    if (error) {
      return Promise.reject({
        message: '"response" not found in api -> data',
      });
    }

    return { gamoogaList: gamoogalist };
  } catch (e) {
    const customMessage = 'Error in add to wishlist api';
    logErrors(e, customMessage);
    throw e;
  }
};


interface RemoveFromWishlist {
  productId: string,
}


export const wishlistRemove = async (params: RemoveFromWishlist) => {
  const {
    productId,
  } = params;
  const url = `/advancedwishlist/index/remove/item/${productId}`;
  const postData = {
    product: productId,
  };

  try {
    const { data: { error } } = await ApiHelper(`${url}`, 'post', postData);

    if (error) {
      return Promise.reject({
        message: '"response" not found in api -> data',
      });
    }

    return true;
  } catch (error) {
    const customMessage = 'Error in remove from wishlist api';
    logErrors(error, customMessage);
    throw error;
  }
};
